<template>
  <div class="mt-4">
    <h4>Your Details</h4>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="First Name">First Name</label>
        <input
          v-validate="'required'"
          id="FirstName"
          v-model="editModel.FirstName"
          @change="syncFirstName(editModel.FirstName)"
          name="First Name"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("First Name") }}</div>
      </div>
      <div class="form-group col-md-6" v-show="fieldShown">
        <label for="Last Name">Last Name</label>
        <input
          v-validate="'required'"
          id="LastName"
          v-model="editModel.LastName"
          name="Last Name"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Last Name") }}</div>
      </div>
    </div>
    <div class="form-row" v-show="fieldShown">
      <div class="form-group col-md-6">
        <label for="EmailAddress">Email</label>
        <input
          v-validate="'required|email'"
          @change="checkEmailExistance(editModel.Email)"
          @load="checkEmailExistance(editModel.Email)"
          @blur="checkEmailExistance(editModel.Email)"
          @keydown="userIsExist=false"
          id="EmailAddress"
          v-model="editModel.Email"
          name="Email Address"
          type="email"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Email Address") }}</div>
      </div>
      <div class="form-group col-md-6">
        <label for="Phone Number">Phone Number</label>
        <input
          v-validate="'required|numeric|max:11'"
          id="Phone Number"
          v-model="editModel.Phone"
          name="Phone Number"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Phone Number") }}</div>
      </div>
    </div>
    <div v-if="fieldShown && viewConfig.LogIn" class="form-row">
      <div class="form-group col-md-12">
        <div class="custom-control custom-checkbox col-md-12 ml-12">
          <input
            id="newAccount"
            type="checkbox"
            name="customCheckbox"
            :checked="createNewAccount"
            @change="check"
            class="custom-control-input"
            @input="val => $emit('save-user', val.target.checked)"
          />
          <label class="custom-control-label" for="newAccount">
            Register a new account
            <small
              class="light-text d-block"
            >Left unchanged you will be placing your order as a guest</small>
          </label>
        </div>
      </div>
      <div class="form-group col-md-12">
        <div v-if="createNewAccount && userIsExist">
          We already have an account for this email, you can
          <router-link
            class="text-primary"
            :to="{ name: 'login', params: { storeid: $parent.storeid ,forgift: forGift }}"
          >login</router-link>&nbsp;here.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { userIsExist } from "../../../../api/services/userService";
export default {
  name: "MyDetail",
  props: {
    editModel: {
      type: Object,
      default: () => {}
    },
    chargeToRoom: {
      type: Boolean,
      default: false
    },
    forGift: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userIsExist: false,
      createNewAccount: false
    };
  },
  computed: {
    ...mapGetters(["viewConfig", "getTotalPrice"]),
    fieldShown() {
      return this.$parent.fieldShown;
    }
  },
  mounted() {
    this.checkEmailExistance(this.editModel.Email);
  },
  methods: {
    syncFirstName(firstName) {
      this.$parent.syncFirstName(firstName);
    },
    validate() {
      return this.$validator.validateAll();
    },
    checkEmailExistance(email) {
      userIsExist(email)
        .then(result => {
          if (result.length > 0) {
            this.$parent.setUserIsExist(true);
            this.userIsExist = true;
          } else {
            this.$parent.setUserIsExist(false);
            this.userIsExist = false;
          }
        })
        .catch(() => {
          this.$parent.setUserIsExist(false);
          this.userIsExist = false;
        });
    },
    check: function(event) {
      this.createNewAccount = event.target.checked;
    },
    setRegisterNewUserState(state) {
      this.createNewAccount = state;
    }
  }
};
</script>
